export default __webpack_public_path__ + "static/media/MK.6b958c8a.svg";